import React from 'react';
import SkillsComponent from '../components/Skills';

function Skills() {
  return (
    <div className="animate-fade-in-up">
      <SkillsComponent />
    </div>
  );
}

export default Skills;
